import { Navigate, Outlet, useRoutes } from 'react-router-dom';

import * as Configs from '@app/configs';
import DashboardLayout from '@app/layouts/dashboard';
import { AuthGuard, GuestGuard } from '@app/guard';
// import { Page404 } from '@app/components';
import { LoginPage, SetPasswordPage, ForgotPasswordPage, SignUpPage } from '@app/modules/auth';
import { HomeScreen, ViewAllScreen } from '@app/modules/home';

import { PATH_AUTH, PATH_DASHBOARD } from './paths';
import { FavoritesScreen } from '@app/modules/favorites';
import { FindARecipeScreen } from '@app/modules/find-recipe';
import { IngredientBasedRecipeScreen } from '@app/modules/ingredients-based-recipe';
import { RecipeDetailsScreen } from '@app/modules/recipe-detail';
import { MyMealsScreen } from '@app/modules/my-meals';
import { SearchScreen } from '@app/modules/search';
import { OnboardingScreen } from '@app/layouts/on-boarding';

// ----------------------------------------------------------------------

export function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <AuthGuard>
          <Navigate to={Configs.PATH_AFTER_LOGIN} />
        </AuthGuard>
      ),
    },
    {
      element: (
        <GuestGuard>
          <Outlet />
        </GuestGuard>
      ),
      children: [
        {
          path: PATH_AUTH.login,
          element: <LoginPage />,
        },
        {
          path: PATH_AUTH.forgotPassword,
          element: <ForgotPasswordPage />,
        },
        {
          path: PATH_AUTH.setPassword,
          element: <SetPasswordPage />,
        },
        {
          path: PATH_AUTH.signUp,
          element: <SignUpPage />,
        },
        // {
        //   path: '*',
        //   element: <Page404 />,
        // },
      ],
    },
    {
      path: PATH_DASHBOARD.onBoarding,
      element: (
        <AuthGuard>
          <OnboardingScreen />
        </AuthGuard>
      ),
    },
    {
      path: PATH_DASHBOARD.root,
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={Configs.PATH_AFTER_LOGIN} replace />, index: true },
        { path: PATH_DASHBOARD.homeScreen, element: <HomeScreen /> },
        { path: PATH_DASHBOARD.myMealsScreen, element: <MyMealsScreen /> },
        { path: PATH_DASHBOARD.findARecipeScreen, element: <FindARecipeScreen /> },
        { path: PATH_DASHBOARD.favoritesScreen, element: <FavoritesScreen /> },
        { path: PATH_DASHBOARD.viewAllScreen, element: <ViewAllScreen /> },
        { path: PATH_DASHBOARD.recipeDetailsScreen, element: <RecipeDetailsScreen /> },
        { path: PATH_DASHBOARD.searchScreen, element: <SearchScreen /> },
        {
          path: PATH_DASHBOARD.ingredientBasedRecipeScreen,
          element: <IngredientBasedRecipeScreen />,
        },
        // {
        //   path: '*',
        //   element: <Page404 />,
        // },
      ],
    },
  ]);
}
